import React, { Component, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import Loadable from 'react-loadable';
import axios from 'axios';

import '../../node_modules/font-awesome/scss/font-awesome.scss';
import 'antd/dist/antd.css';

import Loader from './layout/Loader'
import Aux from "../hoc/_Aux";
import ScrollToTop from './layout/ScrollToTop';
import routes from "../route";
import ProtectedRoute from './ProtectedRoute';

const token = localStorage.getItem('token');

// axios.defaults.baseURL = 'http://192.168.3.117:30613/v1';
// axios.defaults.baseURL = 'https://plm.anugrah-argon.com/apidev/v1';
// axios.defaults.baseURL = 'http://localhost:8170/api/v1';

// API PRODUCTION
axios.defaults.baseURL = 'https://plm.anugrah-argon.com/api/v1';

if(token){
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}
axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.request.use(request => {
    console.log(request);
    // Edit request config
    return request;
}, error => {
    console.log(error);
    return Promise.reject(error);
});

axios.interceptors.response.use(response => {
    let result = response.data;
    if(!result.success && result.message === 'TokenExpiredError'){
        localStorage.removeItem('lov');
        localStorage.removeItem('user');
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('token');
        return;
    }
    // Edit response config
    return response;
}, error => {
    console.log(error);
    return Promise.reject(error);
});

const AdminLayout = Loadable({
    loader: () => import('./layout/AdminLayout'),
    loading: Loader
});

class App extends Component {
    render() {
        const menu = routes.map((route, index) => {
          return (route.component) ? (
              <Route 
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  render={props => (
                      <route.component {...props} />
                  )} />
          ) : (null);
        });

        return (
            <Aux>
                <ScrollToTop>
                    <Suspense fallback={<Loader/>}>
                        <Switch>
                            {menu}
                            <ProtectedRoute path="/" component={AdminLayout} />
                        </Switch>
                    </Suspense>
                </ScrollToTop>
            </Aux>
        );
    }
}

export default App;
